(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["measurements"] && !Shopify.designMode) return;
  try {
    
  function handleClickEvent(event) {
    var element = event.currentTarget;

    // Set type as selected
    document.querySelectorAll('.measurements .measurements-types-container a.measurement-type').forEach(function(type) {
      if (type.dataset.type == element.dataset.type) {
        type.classList.add('selected');
      } else {
        type.classList.remove('selected');
      }
    });

    // Show size chart for selected
    document.querySelectorAll('.measurements .measurements-size-charts-container table.size-chart').forEach(function(chart) {
      if (chart.dataset.type === element.dataset.type) {
        chart.classList.remove('hidden');
      } else {
        chart.classList.add('hidden');
      }
    });
  }

  function init() {
    document.querySelectorAll('.measurements .measurements-types-container a.measurement-type').forEach(function(type) {
      type.addEventListener('click', handleClickEvent);
      type.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClickEvent({ currentTarget: type }); } });
    });

    var measurement = document.querySelector('.measurements .measurements-types-container a.measurement-type');
    if (measurement) {
      measurement.click();
    }
  }

  function unload() {
    document.querySelectorAll('.measurements .measurements-types-container a.measurement-type').forEach(function(type) {
      type.removeEventListener('click', handleClickEvent);
    });
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', unload);
  }

  init();

  } catch(e) { console.error(e); }
})();
})();
